var AutoMapperJs;
(function (AutoMapperJs) {
    'use strict';
    var DestinationTransformationType;
    (function (DestinationTransformationType) {
        DestinationTransformationType[DestinationTransformationType["Constant"] = 1] = "Constant";
        DestinationTransformationType[DestinationTransformationType["MemberOptions"] = 2] = "MemberOptions";
        DestinationTransformationType[DestinationTransformationType["AsyncMemberOptions"] = 4] = "AsyncMemberOptions";
        DestinationTransformationType[DestinationTransformationType["SourceMemberOptions"] = 8] = "SourceMemberOptions";
        DestinationTransformationType[DestinationTransformationType["AsyncSourceMemberOptions"] = 16] = "AsyncSourceMemberOptions";
    })(DestinationTransformationType = AutoMapperJs.DestinationTransformationType || (AutoMapperJs.DestinationTransformationType = {}));
})(AutoMapperJs || (AutoMapperJs = {}));

//# sourceMappingURL=AutoMapperEnumerations.js.map
